<template>
  <div style="text-align:right;">
    <el-dropdown
      class="tst-property-menu"
      v-if="this.property.candelete == true || this.property.canedit == true"
      trigger="click"
      @command="handleCommand"
    >
      <el-button v-on:click.stop type="text" style="padding-top:7px;">
        <i class="el-icon-s-operation" style="font-size: 18px;"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item class="tst-edit-property-option" command="OpenEditPropertyForm" v-if="this.property.canedit == true">
          <i class="fa fa-edit mt-2" />Edit Property
        </el-dropdown-item>
        
        <el-dropdown-item class="tst-delete-property-option" command="DeleteProperty" v-if="this.property.candelete == true">
          <i class="fa fa-trash mt-2" />Delete Property
        </el-dropdown-item>
        <!-- <el-dropdown-item
          class="tst-leave-property-option"
          command="OpenLeavePropertyForm"
          v-if="this.property.canleaveproperty == true"
        >
          <i class="fa fa-trash mt-2" />Leave Property
        </el-dropdown-item> -->
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    property: Object
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    handleCommand(command) {
      if (command == "OpenEditPropertyForm")
        this.$emit("open-edit-property-form", this.property);
      if (command == "DeleteProperty")
        this.$emit("delete-property", this.property);
      if (command == "OpenLeavePropertyForm")
        this.$emit("open-leave-property-form", this.property);
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  }
};
</script>

<style scoped>
.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>